import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router";

export type NavLinkItem = {
    type: "link";
    to: string;
    label: string;
    icon: React.ReactNode;
    active?: boolean;
    visible?: boolean;
};

export type NavDividerItem = {
    type: "divider";
};

export type NavFunctionItem = {
    type: "function";
    label: string;
    icon: React.ReactNode;
    onClick: () => void;
    visible?: boolean;
};

export type NavItemType = NavLinkItem | NavDividerItem | NavFunctionItem;

export function NavItem(props: NavItemType & { active?: boolean }) {
    if (props.type === "link") {
        const { to, icon, label, active } = props;
        return (
            <ListItem disablePadding>
                <ListItemButton
                    component={Link}
                    to={to}
                    selected={active}
                    sx={{
                        mx: 1,
                        my: 0.8,
                        pl: 2.2,
                        borderRadius: 25,
                        border: active ? "1px solid" : "none",
                        borderColor: "primary.main",
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: 36,
                            color: active ? "primary.main" : "secondary",
                        }}
                    >
                        {icon}
                    </ListItemIcon>
                    <ListItemText
                        primary={label}
                        slotProps={{
                            primary: {
                                fontWeight: active ? 600 : 500,
                            },
                        }}
                    />
                </ListItemButton>
            </ListItem>
        );
    }
    if (props.type === "divider") {
        return null;
    }

    // function type
    const func = props as NavFunctionItem;
    const { icon, label, onClick } = func;
    return (
        <ListItem disablePadding>
            <ListItemButton
                onClick={onClick}
                sx={{
                    mx: 1,
                    my: 0.8,
                    pl: 2.2,
                    borderRadius: 25,
                }}
            >
                <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
                <ListItemText
                    primary={label}
                    slotProps={{
                        primary: {
                            fontWeight: 500,
                        },
                    }}
                />
            </ListItemButton>
        </ListItem>
    );
}
